var documentWidth = $(document).width();
$(window).resize(function () {
  documentWidth = $(document).width();
});

$(function () {
  // close auto complete
  $(".js-tour-booking").delegate(
    ".js-close-auto-complete",
    "click",
    function () {
      $(".js-tour-booking-input").autocomplete("close");
      $(".js-autocomplete-list>ul").hide();
      $("html").removeClass("no-scroll");
      $(".js-tour-booking-item").removeClass("show-mobile");
    }
  );

  // close auto complete list when click in out of it
  $(document).click(function (e) {
    if ($(e.target).closest("js-tour-booking").length === 0) {
      $(".js-autocomplete-list").removeClass("show");
      $(".js-autocomplete-field").removeClass("open");
    }
  });

  // module four column tours hover effect
  $(".four-column-tours__content .four-column-tours__card").each(function () {
    $(this).hover(
      function () {
        $(this).siblings().addClass("small");
        $(this).addClass("active");
      },
      function () {
        $(this).siblings().removeClass("small");
        $(this).removeClass("active");
      }
    );
  });

  // update auto complete after type
  function getResult(input) {
    var dataUrl = "/search/tour/";
    if ($(input).val()) {
      dataUrl += $(input).val();
    }
    return dataUrl;
  }

  $(".js-tour-booking-input")
    .autocomplete({
      minLength: 0,
      source: function (request, response) {
        if (request.term === "") {
          var items = [
            {
              CoverUrl: null,
              Href: "/fa/tours/france-tour/",
              Id: 1,
              Slug: "france-tour",
              Title: "تور فرانسه",
              Type: 1,
            },
          ];

          response(items);
        } else {
          var url = getResult($(".js-tour-booking-input"));
          $.getJSON(url).done(function (serverResponse) {
            response(serverResponse.TourQuickSearchs);
          });
        }
      },
      appendTo: $(".js-tour-booking-input").next(),
      search: function () {
        if (documentWidth < 992) {
          $("html").addClass("no-scroll");
          $(this).closest(".js-tour-booking-item").addClass("show-mobile");
        }
      },
      open: function () {
        var inputObj = $(this);

        inputObj
          .next(".js-autocomplete-list")
          .children("ul")
          .css({
            top: "+=" + 16,
          });
      },
      select: function (event, ui) {
        window.location = ui.item.Href;
      },
      focus: function (e, ui) {
        $(".js-tour-booking-input").attr("placeholder", "");
        setTimeout(function () {
          $(".js-tour-booking-input").val(ui.item.Title);
        }, 1);
      },
      close: function (e, ui) {
        $(".js-tour-booking-input").attr("placeholder", "مقصد کجاست؟");
        $(".js-tour-booking-item").removeClass("show-mobile");
        $("html").removeClass("no-scroll");
      },
    })
    .bind("focus", function () {
      $(this).keydown();
    })
    .autocomplete("instance")._renderItem = function (ul, item) {
      var iconClass;
      switch (item.Type) {
        case 1:
        case 2:
          iconClass = "icon-pin";
          break;

        case 3:
        case 4:
          iconClass = "icon-pin";
          break;

        default:
          iconClass = "icon-pin";
      }

      return $("<li>")
        .append(
          "<a href='" +
          item.Href +
          "' onclick=\"ga('send', 'event', 'FirstPage', 'SearchItem', '" +
          item.Title +
          "')\" > <i class='" +
          iconClass +
          "'></i> <span>" +
          item.Title +
          "</span></a>"
        )
        .appendTo(ul);
    };

  // show datepicker or autocomplete list when click on parent box
  $(document).delegate(".js-booking-field-wrapper", "click", function (e) {
    if ($(this).find(".js-tour-booking-input").length) {
      if (
        !e.target.closest(".js-tour-booking-input") &&
        !e.target.closest(".js-autocomplete-list") &&
        !e.target.closest(".js-close-auto-complete")
      ) {
        $(this).find(".js-tour-booking-input").trigger("focus");
      }
    }
  });

  $(document).delegate(".js-search-filed", "focus", function () {
    if ($(window).width() > 992) {
      $(this)
        .closest(".booking-search__field")
        .addClass("booking-search__field--active");
    }
  });

  $(document).delegate(".js-search-filed", "blur", function () {
    if ($(window).width() > 992) {
      $(this)
        .closest(".booking-search__field")
        .removeClass("booking-search__field--active");
    }
  });
});
